import {
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router, ActivatedRoute } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { AddServiceTimingsComponent } from "src/app/shared/components/add-service-timings/add-service-timings.component";
import { SelectBusinessCountryComponent } from "src/app/shared/components/select-business-country/select-business-country.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { MeetingDataComponent } from "../new-v2-component/meeting-data/meeting-data.component";
import { YoutubeEmbedVideoComponent } from "../new-v2-component/youtube-embed-video/youtube-embed-video.component";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ITableColumnHeader } from "src/app/models/table-column-header";
import { AddCustomerComponent } from "src/app/shared/components/add-customer/add-customer.component";
import { CreateInvoiceForCustomersComponent } from "src/app/shared/components/create-invoice-for-customers/create-invoice-for-customers.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { CustomersViewDetailsComponent } from "../new-v2-component/customers-view-details/customers-view-details.component";
import { PaymentIntimationComponent } from "src/app/shared/components/payment-intimation/payment-intimation.component";
import { formatDate } from "@angular/common";
import { CreateInvoiceForFitnessComponent } from "src/app/shared/components/create-invoice-for-fitness/create-invoice-for-fitness.component";
import { MarkAbsentComponent } from "../new-v2-component/mark-absent/mark-absent.component";
import { PhoneCheckForMemberComponent } from "../new-v2-component/phone-check-for-member/phone-check-for-member.component";
import { COUNTRY_CODES } from "src/app/shared/data/country-codes";
import { AuthService } from "src/app/providers/auth.service";
import { PhoneCheckForMemberFromLeftPanelComponent } from "../new-v2-component/phone-check-for-member-from-left-panel/phone-check-for-member-from-left-panel.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SlotTimingsComponent } from "../new-v2-component/slot-timings/slot-timings.component";
import { AddJoiningInterestTimingsComponent } from "../new-v2-component/add-joining-interest-timings/add-joining-interest-timings.component";
import { debounceTime, filter, switchMap } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
declare var google: any;

@Component({
  selector: "sm-enroll-new-member",
  templateUrl: "./enroll-new-member.component.html",
  styleUrls: ["./enroll-new-member.component.scss"],
})
export class EnrollNewMemberComponent implements OnInit, OnDestroy {
  toShowMap: boolean = false;
  toShowSessionInfo: boolean = false;
  online_session_link: any = null;
  online_session_notes: any = null;
  online_session_app: any = null;
  panelState: any = [true, false, false, false, false];
  step: number = 1;
  isEntityIndividual: any;
  hidediv: boolean = false;
  searchString: FormControl = new FormControl("");
  loader: boolean = false;
  apisub: Subscription;
  businessListData: any[] = [];
  serviceTimings: any[] = [];
  finalServiceTimings: any[] = [];
  selectedBusiness: any;
  selectedServiceType: any = "1";
  groupedServiceTimings: any = null;
  page: number = 1;
  datalength!: number;
  toShowTimings: boolean = false;
  membersData: any[] = [];
  form: FormGroup;

  daysOfWeek = [
    { day: 1, name: "Sunday" },
    { day: 2, name: "Monday" },
    { day: 3, name: "Tuesday" },
    { day: 4, name: "Wednesday" },
    { day: 5, name: "Thursday" },
    { day: 6, name: "Friday" },
    { day: 7, name: "Saturday" },
  ];
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "name",
    },
    {
      columnName: "phone",
      columnProperty: "member_phone",
    },
    {
      columnName: "gender",
      columnProperty: "gender",
    },
    {
      columnName: "last payment date",
      columnProperty: "last_payment_dt",
    },
    {
      columnName: "Service mode",
      columnProperty: "s_mode",
    },
    {
      columnName: "total due",
      columnProperty: "total_due",
    },
  ];
  isEmployeeAndHasBusinessButDoesNotHaveAccess: boolean = false;
  uploadedImage: any = {};
  membershipSettings: any = {};

  constructor(
    private apiservice: ApiService,
    private loaderservice: LoaderServiceService,
    private navservice: NavigationService,
    private router: Router,
    private _modelRef: MatDialog,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private authService: AuthService,
    private _snackBar: MatSnackBar,
    private fb: FormBuilder,
    private http: HttpClient,
    private _ngZone: NgZone,
  ) {
    setTimeout(() => {
      if (
        typeof google === "undefined" ||
        !google.maps ||
        !google.maps.places
      ) {
        console.error("Google Maps API failed to load in Safari <15.");
        return;
      }

      this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
      this.geocoder = new google.maps.Geocoder();
    }, 500);
    this.form = this.fb.group({
      items: this.fb.array([]),
    });
    this.navservice.hideSidebarAndNav = false;
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_MEMBER_AUTO_INVOICE_SENDING_SETTINGS
      ) {
        this.membershipSettings = {};
        if (resdata.result) {
          this.membershipSettings = resdata.result[0];
          if (
            this.membershipSettings?.default_online_session_link_status == 1
          ) {
            this.online_session_link =
              this.membershipSettings?.default_online_session_link;
            this.online_session_app =
              this.membershipSettings?.default_online_session_app;
          }
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_BASIC_ENTITY_LIST
      ) {
        this.businessListData = [];
        if (resdata.result) {
          this.businessListData = resdata.result;
          this.businessListData.forEach((element: any) => {
            // Parse if string
            element.employee_functionality_list =
              typeof element.employee_functionality_list === "string"
                ? JSON.parse(element.employee_functionality_list)
                : element.employee_functionality_list;

            const list = element.employee_functionality_list || [];

            // Set defaults
            element.member_access = 0;
            element.customer_access = 0;
            element.service_access = 0;
            element.bookings_access = 0;

            if (Array.isArray(list)) {
              list.forEach((fn: any) => {
                const access = fn?.access_status === 1 ? 1 : 0;
                const name = fn?.functionality_name || "";

                switch (name) {
                  case "Member management":
                    element.member_access = access;
                    break;

                  case "Customer management":
                    element.customer_access = access;
                    break;

                  case "Services & Packages":
                    element.service_access = access;
                    break;

                  case "Booking history":
                    element.bookings_access = access;
                    break;

                  case "Shop/In-Premise operation":
                    element.shop_bookings_access = access;
                    break;

                  case "Home service operation":
                    element.home_bookings_access = access;
                    break;

                  case "Virtual service operation":
                    element.virtual_bookings_access = access;
                    break;

                  case "Invoice history":
                    element.invoice_history_access = access;
                    break;

                  case "Shop/In-Premise Invoicing":
                    element.shop_invoice_access = access;
                    break;

                  case "Home service invoicing":
                    element.home_invoice_access = access;
                    break;

                  case "Virtual service invoicing":
                    element.virtual_invoice_access = access;
                    break;
                }
              });
            }
          });
          let checkForAccessLength = this.businessListData.length;
          this.businessListData = this.businessListData
            .map((element: any) => ({
              ...element, // Spread existing properties
              isSelected: 0, // Add the isSelected property
            }))
            .filter(
              (element: any) =>
                (element.is_owner == 1 &&
                  element.entitySubscriptionInfo &&
                  element.entitySubscriptionInfo !== "null") ||
                (element.is_owner != 1 &&
                  element.entitySubscriptionInfo &&
                  element.entitySubscriptionInfo !== "null" &&
                  element.employeeSubscriptionInfo &&
                  element.employeeSubscriptionInfo !== "null" &&
                  element.employee_status == 1 &&
                  element.member_access == 1),
            );
          if (checkForAccessLength - this.businessListData.length > 0) {
            this.isEmployeeAndHasBusinessButDoesNotHaveAccess = true;
          }
          if (this.businessListData.length > 0) {
            this.businessListData[0].isSelected = 1;
            this.selectedBusiness = this.businessListData[0];

            if (this.selectedBusiness.shop_service_status != 2) {
              this.selectedServiceType = "1";
            } else if (this.selectedBusiness.home_service_status != 2) {
              this.selectedServiceType = "0";
            } else if (this.selectedBusiness.virtual_service_status != 2) {
              this.selectedServiceType = "2";
            }

            localStorage.setItem(
              SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
              this.selectedBusiness.entity_public_hash_id,
            );
            localStorage.setItem(
              SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
              this.selectedBusiness.employee_hash_id,
            );
            sessionStorage.setItem(
              "shop_service_status",
              this.selectedBusiness.shop_service_status,
            );
            sessionStorage.setItem(
              "home_service_status",
              this.selectedBusiness.home_service_status,
            );
            sessionStorage.setItem(
              "virtual_service_status",
              this.selectedBusiness.virtual_service_status,
            );

            sessionStorage.setItem(
              SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_INVOICE_ACCESS,
              this.selectedBusiness.shop_invoice_access,
            );
            sessionStorage.setItem(
              SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_INVOICE_ACCESS,
              this.selectedBusiness.home_invoice_access,
            );
            sessionStorage.setItem(
              SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_INVOICE_ACCESS,
              this.selectedBusiness.virtual_invoice_access,
            );

            this.isEntityIndividual =
              this.selectedBusiness.revenue_model == 2 ? "1" : "0";

            this.isEntityForeign =
              this.selectedBusiness.currency == "INR" ? "0" : "1";

            localStorage.setItem(
              SM_CONSTANTS.IS_ENTITY_FOREIGN,
              this.isEntityForeign,
            );

            sessionStorage.setItem(
              "isEntityIndividual",
              this.selectedBusiness.revenue_model == 2 ? "1" : "0",
            );
            let countryList: any[] = COUNTRY_CODES;

            let selectedCurrency = {
              currency: this.selectedBusiness.currency,
              currencySymbol: this.selectedBusiness.currency_symbol,
              countryCode: this.selectedBusiness.entity_country_code,
              code: countryList.find(
                (country) =>
                  country.dial_code ===
                    this.selectedBusiness.entity_country_code &&
                  country.currency === this.selectedBusiness.currency,
              )?.code,
            };
            sessionStorage.setItem(
              SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
              JSON.stringify(selectedCurrency),
            );

            this.selectedCountryCode = this.countryList.find(
              (country) =>
                country.dial_code ===
                  this.selectedBusiness.entity_country_code &&
                country.code === selectedCurrency.code,
            );
          }
          console.log("bl", this.selectedBusiness);
          if (this.selectedBusiness) {
            this.authService.setUserRole(
              this.selectedBusiness.is_owner == 1 ? "owner" : "employee",
            );

            let dateobj = this.getOneHourSlot(new Date());
            this.startTime = dateobj.start;
            this.endTime = dateobj.end;
            if (this.isEntityIndividual == "1") {
              let tempobj = {
                startTime: dateobj.start,
                endTime: dateobj.end,
                day: {
                  dayName: this.getDayName(new Date().getDay()),
                  day: new Date().getDay() + 1,
                  timeSlots: [],
                  is_selected: 1,
                },
              };

              this.selectedDays = [tempobj];
            }

            if (this.isEntityForeign == "0") {
              this.apiservice.getEntityTaxSlabData(
                this.selectedBusiness.hash_id,
              );
            } else if (this.isEntityForeign == "1") {
              this.apiservice.getInternationalEntityTaxSlabsData(
                this.selectedBusiness.hash_id,
              );
            }

            this.apiservice.getEntityProductList(
              this.selectedBusiness.hash_id,
              "1",
            );
            this.apiservice.getServicesTypesList(
              this.selectedBusiness.entity_public_hash_id,
              "0",
              "0",
            );
            this.apiservice.getBillDiscountData(
              this.selectedBusiness.entity_public_hash_id,
            );

            this.apiservice.getEmployeeList(this.selectedBusiness.hash_id);

            this.apiservice.getMemberAutoInvoiceSendingSettings(
              this.selectedBusiness.hash_id,
            );
          }
        }

        if (this.businessListData.length > 0) {
          this.loaderservice.showLoader = false;
          this.loader = false;
        } else {
          this.loaderservice.showLoader = false;
          this.loader = false;
        }
      }

      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_ENROLL_MEMBERS
      ) {
        if (resdata.result) {
          if (resdata.result.errorcode == 0) {
            if (
              resdata.result.whatsapp_share == 0 &&
              (resdata.result.email_share == 1 ||
                resdata.result.email_share == 2 ||
                resdata.result.email_share == 3)
            ) {
              const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
                width: "500px",
                data: {
                  title: "Pack expired!",
                  message:
                    "Enrolment successfully done for the new member. But unable to send the confirmation via WhatsApp as Premium pack expired for this business. ",
                  okbtn: "Buy pack",
                  cancelbtn: "Cancel",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
                },
                disableClose: true,
              });
              dialogRef.afterClosed().subscribe((result) => {
                console.log(result);
                if (result) {
                  this.router.navigate(
                    ["/businesses", "details", "plan-and-renew"],
                    {
                      queryParams: {
                        entityHash: this.selectedBusiness.hash_id,
                      },
                    },
                  );
                }
              });
            } else if (
              resdata.result.whatsapp_share == 1 &&
              resdata.result.email_share == 0
            ) {
              const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
                width: "500px",
                data: {
                  title: "Pack expired!",
                  message:
                    "Enrolment successfully done for the new member. But unable to send the confirmation Email as Premium pack expired for this business. ",
                  okbtn: "Buy pack",
                  cancelbtn: "Cancel",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
                },
                disableClose: true,
              });
              dialogRef.afterClosed().subscribe((result) => {
                console.log(result);
                if (result) {
                  this.router.navigate(
                    ["/businesses", "details", "plan-and-renew"],
                    {
                      queryParams: {
                        entityHash: this.selectedBusiness.hash_id,
                      },
                    },
                  );
                }
              });
            } else if (
              resdata.result.whatsapp_share == 0 &&
              resdata.result.email_share == 0
            ) {
              const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
                width: "500px",
                data: {
                  title: "Pack expired!",
                  message:
                    "Enrolment successfully done for the new member. But unable to send the confirmation via Email and WhatsApp as Premium pack expired for this business. ",
                  okbtn: "Buy pack",
                  cancelbtn: "Cancel",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
                },
                disableClose: true,
              });
              dialogRef.afterClosed().subscribe((result) => {
                console.log(result);
                if (result) {
                  this.router.navigate(
                    ["/businesses", "details", "plan-and-renew"],
                    {
                      queryParams: {
                        entityHash: this.selectedBusiness.hash_id,
                      },
                    },
                  );
                }
              });
            }
            this.resetEverything();
            if (this.selectedBusiness.shop_service_status != 2) {
              this.selectedServiceType = "1";
            } else if (this.selectedBusiness.home_service_status != 2) {
              this.selectedServiceType = "0";
            } else if (this.selectedBusiness.virtual_service_status != 2) {
              this.selectedServiceType = "2";
            }
            this.changeServiceType(this.selectedServiceType)
            let dateobj = this.getOneHourSlot(new Date());
            this.startTime = dateobj.start;
            this.endTime = dateobj.end;
            if (this.isEntityIndividual == "1") {
              let tempobj = {
                startTime: dateobj.start,
                endTime: dateobj.end,
                day: {
                  dayName: this.getDayName(new Date().getDay()),
                  day: new Date().getDay() + 1,
                  timeSlots: [],
                  is_selected: 1,
                },
              };

              this.selectedDays = [tempobj];
            }
            this._snackBar.open("Member added successfully.", "", {
              duration: 3000,
            });
          } else if (resdata.result.errorcode == 1) {
            // this.loaderservice.showLoader = false;
            const dialogRef = this._modelRef.open(
              CustomConfirmDialogComponent,
              {
                width: "500px",
                data: {
                  title: "Alert",
                  message:
                    "There's another member with the same name and phone number exists. If you really want to create one, change the name or phone number.",
                  okbtn: "Ok",
                  cancelbtn: "Cancel",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                },
                disableClose: true,
              },
            );
          } else if (resdata.result.errorcode == 2) {
            // this.loaderservice.showLoader = false;
            const dialogRef = this._modelRef.open(
              CustomConfirmDialogComponent,
              {
                width: "500px",
                data: {
                  title: "Alert",
                  message:
                    "There's a person with the same name and phone number exists as your ex member. You can revive the membership again in 'Ex-members' section. Or change the member info.",
                  okbtn: "Ok",
                  cancelbtn: "Cancel",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                },
                disableClose: true,
              },
            );
          }
          // this.loaderservice.showLoader = false
          // this.activemodal.close({msg: 'success'})
        }
        this.loaderservice.showLoader = false;
      }

      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_DISCOUNT
      ) {
        this.discountInfo = null;
        if (resdata.result) {
          this.discountInfo = resdata.result;
        }
        this.loaderservice.showLoader = false;
        this.loader = false;
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ACCOUNT_DATA_BY_PHONE_NUMBER
      ) {
        if (resdata.result) {
          resdata.result.forEach((element: any) => {
            element.selected = false;
          });
          this.loaderservice.showLoader = false;

          let dialogref = this.dialog.open(
            PhoneCheckForMemberFromLeftPanelComponent,
            {
              width: "500px",
              data: {
                title: "Add member",
                ref: this.dialog,
                data: resdata.result,
                phone: this.phone,
              },
            },
          );
          dialogref.afterClosed().subscribe((data) => {
            if (data) {
              console.log(data);
              this.memberData.name = data[0].name;
              this.memberData.phone = this.phone;
              this.memberimg.img = data[0].image_thumb_url;
              this.memberimg.thumb = data[0].image_thumb_url;
              this.step = 2;
              this.isPhoneDisabled = true;
            }
          });
        } else {
          this.loaderservice.showLoader = false;
          this.memberData.phone = this.phone;
          this.step = 2;
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.GET_SERVICES_TYPES_LIST_RESULT
      ) {
        console.log(resdata);

        this.serviceList = [];
        if (resdata.result) {
          if (this.selectedServiceType == "1") {
            resdata.result.forEach((element: any) => {
              if (element.shopStatus == 1 && element.status == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
          } else if (this.selectedServiceType == "0") {
            resdata.result.forEach((element: any) => {
              if (element.homeStatus == 1 && element.status == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          } else if (this.selectedServiceType == "2") {
            resdata.result.forEach((element: any) => {
              if (element.for_virtual == 1 && element.status == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }
        }

        this.loaderservice.showLoader = false;
        // this.calculateCouponDiscount();
      }
      if (resdata.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        this.uploadedImage = {};
        console.log(resdata.result.url);
        this._ngZone.run(() => {
          setTimeout(() => {
            this.uploadedImage.imgUrl = resdata.result?.url;
            this.uploadedImage.thumbnail = resdata.result?.thumbnail;

            this.memberimg.img = resdata.result?.url;
            this.memberimg.thumb = resdata.result?.thumbnail;

            // this.memberData.profileThumbImg = resdata.result?.url
            // this.memberData.profileThumbImgReal = resdata.result?.thumbnail

            // this.memberData.profileImg = resdata.result?.url
            this.loaderservice.showLoader = false;
          }, 3000);
        });
        // this.newSalaryData.imgUrl = res.result?.url;fff
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_SLAB_DATA
      ) {
        this.taxSlabData = [];
        if (resdata.result) {
          this.taxSlabData = resdata.result.filter(
            (item: any) => item.tax_collection_status == 1,
          );
        } else {
          // this.isTaxApplicable = true
          // this.loader.showLoader = false
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_SLAB_DATA
      ) {
        this.taxSlabData = [];
        if (resdata.result) {
          this.taxSlabData = resdata.result.filter(
            (item: any) => item.tax_collection_status == 1,
          );
        } else {
          // this.isTaxApplicable = true
          // this.loader.showLoader = false
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_PRODUCT_LIST
      ) {
        console.log(resdata);

        this.productsList = [];
        if (resdata.result) {
          if (this.selectedServiceType == "1") {
            resdata.result.forEach((element: any) => {
              if (element.shop_status == 1 && element.status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
          } else if (this.selectedServiceType == "0") {
            resdata.result.forEach((element: any) => {
              if (element.home_status == 1 && element.status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          } else if (this.selectedServiceType == "2") {
            resdata.result.forEach((element: any) => {
              if (element.virtual_status == 1 && element.status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }
        }
      }
      if (resdata.responseType === SM_CONSTANTS.GET_EMPLOYEE_LIST_RESULT) {
        this.employeeList = [];
        if (resdata.result) {
          resdata.result.forEach((element: any) => {
            if (element.isExEmployee != 1) {
              this.employeeList.push(element);
            }
          });
        }
      }
    });
  }

  ngOnInit(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
      queryParamsHandling: "", // Clears all other params
      replaceUrl: true,
    });
    // localStorage.removeItem(SM_CONSTANTS.CURRENT_ENTITY_HASH);
    sessionStorage.removeItem("mefrp");
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.apiservice.getBasicEntityList();
  }
  createNewBusiness() {
    this.router.navigate(["purchased-plan"]);
  }

  selectedValue: string = "1";
  pageNo: number = 1;
  changeChip(value: string) {
    this.selectedValue = value;
    this.loader = true;
    this.loaderservice.showLoader = true;
    // if(value == '0'){
    //   this.apiservice.getCustomersByEntityId(this.selectedBusiness.hash_id,  this.page.toString())
    // }
    // else if(value == '1'){
    //   this.apiservice.getCustomersWithDuesByEntityId(this.selectedBusiness.hash_id,  this.page.toString())
    // }
    // else if(value == '2'){
    //   this.apiservice.getLongAbsentCustomersByEntityId(this.selectedBusiness.hash_id,  this.page.toString())
    // }
    this.apiservice.getEnrolledMembersListByType(
      this.selectedBusiness.hash_id,
      this.selectedValue,
      this.pageNo,
    );
  }

  selectBusiness(index: any) {
    this.resetEverything();

    this.businessListData.forEach((element: any) => {
      element.isSelected = 0;
    });
    this.businessListData[index].isSelected = 1;
    this.selectedBusiness = this.businessListData[index];
    if (this.selectedBusiness.shop_service_status != 2) {
      this.selectedServiceType = "1";
    } else if (this.selectedBusiness.home_service_status != 2) {
      this.selectedServiceType = "0";
    } else if (this.selectedBusiness.virtual_service_status != 2) {
      this.selectedServiceType = "2";
    }
    this.isEntityIndividual =
      this.selectedBusiness.revenue_model == 2 ? "1" : "0";

    let dateobj = this.getOneHourSlot(new Date());
    this.startTime = dateobj.start;
    this.endTime = dateobj.end;
    if (this.isEntityIndividual == "1") {
      let tempobj = {
        startTime: dateobj.start,
        endTime: dateobj.end,
        day: {
          dayName: this.getDayName(new Date().getDay()),
          day: new Date().getDay() + 1,
          timeSlots: [],
          is_selected: 1,
        },
      };

      this.selectedDays = [tempobj];
    }

    this.isEntityForeign = this.selectedBusiness.currency == "INR" ? "0" : "1";

    localStorage.setItem(SM_CONSTANTS.IS_ENTITY_FOREIGN, this.isEntityForeign);
    sessionStorage.setItem(
      "isEntityIndividual",
      this.selectedBusiness.revenue_model == 2 ? "1" : "0",
    );
    let countryList: any[] = COUNTRY_CODES;

    let selectedCurrency = {
      currency: this.selectedBusiness.currency,
      currencySymbol: this.selectedBusiness.currency_symbol,
      countryCode: this.selectedBusiness.entity_country_code,
      code: countryList.find(
        (country) =>
          country.dial_code === this.selectedBusiness.entity_country_code &&
          country.currency === this.selectedBusiness.currency,
      )?.code,
    };
    sessionStorage.setItem(
      SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
      JSON.stringify(selectedCurrency),
    );
    localStorage.setItem(
      SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
      this.selectedBusiness.entity_public_hash_id,
    );
    sessionStorage.setItem(
      "shop_service_status",
      this.selectedBusiness.shop_service_status,
    );
    sessionStorage.setItem(
      "home_service_status",
      this.selectedBusiness.home_service_status,
    );
    sessionStorage.setItem(
      "virtual_service_status",
      this.selectedBusiness.virtual_service_status,
    );

    sessionStorage.setItem(
      SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_INVOICE_ACCESS,
      this.selectedBusiness.shop_invoice_access,
    );
    sessionStorage.setItem(
      SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_INVOICE_ACCESS,
      this.selectedBusiness.home_invoice_access,
    );
    sessionStorage.setItem(
      SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_INVOICE_ACCESS,
      this.selectedBusiness.virtual_invoice_access,
    );

    localStorage.setItem(
      SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
      this.selectedBusiness.employee_hash_id,
    );

    this.authService.setUserRole(
      this.selectedBusiness.is_owner == 1 ? "owner" : "employee",
    );

    this.selectedCountryCode = this.countryList.find(
      (country) =>
        country.dial_code === this.selectedBusiness.entity_country_code &&
        country.code === selectedCurrency.code,
    );

    this.loaderservice.showLoader = true;

    if (this.isEntityForeign == "0") {
      this.apiservice.getEntityTaxSlabData(this.selectedBusiness.hash_id);
    } else if (this.isEntityForeign == "1") {
      this.apiservice.getInternationalEntityTaxSlabsData(
        this.selectedBusiness.hash_id,
      );
    }

    this.apiservice.getEntityProductList(this.selectedBusiness.hash_id, "1");
    this.apiservice.getServicesTypesList(
      this.selectedBusiness.entity_public_hash_id,
      "0",
      "0",
    );
    this.apiservice.getBillDiscountData(
      this.selectedBusiness.entity_public_hash_id,
    );

    this.apiservice.getEmployeeList(this.selectedBusiness.hash_id);
    this.apiservice.getMemberAutoInvoiceSendingSettings(
      this.selectedBusiness.hash_id,
    );
    // this.hidediv = true;
    // this.loaderservice.showLoader = true;
    // this.changeChip("1");
  }

  firstTimeBelow3: boolean = false;

  searchServiceData() {
    if (this.searchString.value.length >= 3) {
      this.firstTimeBelow3 = true;
      this.page = 1;
      this.apiservice.getMemberDataByKeyword(
        this.selectedBusiness.hash_id,
        this.page.toString(),
        this.searchString.value,
        this.selectedValue,
      );
    } else {
      if (this.firstTimeBelow3) {
        this.firstTimeBelow3 = false;
        this.page = 1;
        this.apiservice.getEnrolledMembersListByType(
          this.selectedBusiness.hash_id,
          this.selectedValue,
          this.pageNo,
        );
      }
    }
  }

  reset() {
    this.firstTimeBelow3 = false;
    this.searchString.reset();
    this.page = 1;
    this.apiservice.getEnrolledMembersListByType(
      this.selectedBusiness.hash_id,
      this.selectedValue,
      this.pageNo,
    );
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }
  openLink(url: string): void {
    window.open(url, "_blank");
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "https://www.youtube.com/embed/jCpDxXA4TZA",
        title: "How to manage members?",
      },
    });
  }

  opencontact() {
    this.router.navigate(["/contact-us"]);
  }

  viewdetailsopen(item: any) {
    this._modelRef.open(CustomersViewDetailsComponent, {
      width: "600px",
      data: {
        customerData: item,
        title: "view details",
        ref: this._modelRef,
      },
    });
  }
  discountInfo: any = null;
  createInvoice(customer: any) {
    let data = {
      entityHash: this.selectedBusiness.hash_id,
      eph: this.selectedBusiness.entity_public_hash_id,
      customer: customer,
      discountInfo: this.discountInfo,
    };
    // this._modelRef.open(AddNewBookingComponent, {
    //   width: '700px',
    //   data: {
    //     title: 'New Booking',
    //     ref: this._modelRef,
    //     data: data
    //   },
    // });
    this._modelRef.open(CreateInvoiceForCustomersComponent, {
      width: "700px",
      data: {
        title: "New Invoice",
        ref: this._modelRef,
        data: data,
      },
    });
  }

  addcustomer() {
    let dialogref = this.dialog.open(AddCustomerComponent, {
      width: "500px",
      disableClose: true,
      data: {
        entityHash: this.selectedBusiness.hash_id,
        eph: this.selectedBusiness.entity_public_hash_id,
        link: "",
        title: "Add customer",
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        if (res[0].errorcode == 1) {
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's another customer with the same name and phone number exists. If you really want to create one, change the name or phone number.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else {
          this.loaderservice.showLoader = true;
          this.apiservice.getCustomersByEntityId(
            this.selectedBusiness.hash_id,
            this.page.toString(),
          );
        }
      }
    });
  }

  openAllBookings(item: any) {
    console.log(item);
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(["all-bookings"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {
        phone: item.phone,
        mn: item.name,
        entityHash: this.selectedBusiness.hash_id,
        eph: this.selectedBusiness.entity_public_hash_id,
      },
    });
  }
  openAllPayments(item: any) {
    console.log(item);
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(["all-payments"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {
        phone: item.phone,
        code: item.country_code,
        mn: item.name,
        entityHash: this.selectedBusiness.hash_id,
        eph: this.selectedBusiness.entity_public_hash_id,
      },
    });
  }
  openDueBookings(item: any) {
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(["due-bookings"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {
        phone: item.phone,
        mn: item.name,
        entityHash: this.selectedBusiness.hash_id,
        eph: this.selectedBusiness.entity_public_hash_id,
      },
    });
  }

  deleteCustomer(item: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this customer?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          customerHash: item.hash_id,
          entityHash: this.selectedBusiness.hash_id,
        };

        this.loaderservice.showLoader = true;
        this.apiservice.deleteEntityCustomer(obj);
      }
    });
  }

  selectcountry() {
    let dialogref = this.dialog.open(SelectBusinessCountryComponent, {
      width: "500px",
      disableClose: true,
      data: {
        link: "",
        title: "Select business country",
        ref: this.dialog,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this.router.navigate(["purchased-plan"]);
      }
    });
  }

  formatDateToReadable(date: Date): string {
    // Use Angular's formatDate utility for localization and formatting
    return formatDate(date, "MMM d, y", "en-US");
  }

  goviewdetails(rowvalue: any) {
    this.authService.setUserRole(
      this.selectedBusiness.is_owner == 1 ? "owner" : "employee",
    );
    sessionStorage.setItem("mefrp", rowvalue.email);
    this.router.navigate(["member-details"], {
      relativeTo: this.route,
      queryParams: {
        entityHash: this.selectedBusiness.hash_id,
        eph: this.selectedBusiness.entity_public_hash_id,
        memberHash: rowvalue.hash_id,
      },
    });
  }

  openViewAttendance(rowvalue: any) {
    this.router.navigate(["view-attendance"], {
      relativeTo: this.route,
      queryParams: {
        entityHash: this.selectedBusiness.hash_id,
        memberHash: rowvalue.hash_id,
        mn: rowvalue.name,
      },
    });
  }
  createInvoiceForEnrolled(item: any) {
    sessionStorage.setItem("mefrp", item.email);
    let data = {
      entityHash: this.selectedBusiness.hash_id,
      eph: this.selectedBusiness.entity_public_hash_id,
      // serviceType: this.interestType,
      enrolledData: {
        customer_name: item.name,
        customer_country_code: item.country_code,
        customer_phone: item.phone,
        customer_email: item.email,
      },
      memberData: item,
      discountInfo: this.discountInfo,
    };

    this.dialog.open(CreateInvoiceForFitnessComponent, {
      width: "700px",
      data: {
        title: "New Invoice",
        ref: this.dialog,
        data: data,
      },
    });
  }

  openAllInvoices(item: any) {
    sessionStorage.setItem("mefrp", item.email);
    sessionStorage.setItem("currentSelectedMember", item.hash_id);
    console.log(item);

    this.router.navigate(["all-payments"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {
        entityHash: this.selectedBusiness.hash_id,
        memberHash: item.hash_id,
        phone: item.phone,
        code: item.country_code,
        mn: item.name,
      },
    });
  }
  openDueInvoices(item: any) {
    sessionStorage.setItem("mefrp", item.email);
    sessionStorage.setItem("currentSelectedMember", item.hash_id);
    this.router.navigate(["due-payments"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {
        entityHash: this.selectedBusiness.hash_id,
        memberHash: item.hash_id,
        phone: item.phone,
        code: item.country_code,
        mn: item.name,
      },
    });
  }
  openPaymentIntimation(item: any) {
    this._modelRef.open(PaymentIntimationComponent, {
      width: "700px",
      data: {
        title: "Payment Intimation",
        ref: this._modelRef,
        data: item,
        type: 2,
      },
    });
  }
  openmarkabsent(rowvalue: any) {
    this.dialog.open(MarkAbsentComponent, {
      width: "500px",
      disableClose: true,
      data: {
        link: "",
        title: "Mark absent",
        entityHash: this.selectedBusiness.hash_id,
        memberHash: rowvalue.hash_id,
      },
    });
  }

  addmember() {
    // this.dialog.open(AddMemberComponent,{
    //   width:'500px',
    //   disableClose:true,
    //   data:{
    //     link:"",
    //     title: 'Add member'
    //   }})

    let data = {
      entityHash: this.selectedBusiness.hash_id,
      // serviceType: this.interestType,
    };

    let dialogref = this.dialog.open(PhoneCheckForMemberComponent, {
      width: "500px",
      data: {
        title: "Add member",
        ref: this.dialog,
        data: data,
        entityHash: this.selectedBusiness.hash_id,
        eph: this.selectedBusiness.entity_public_hash_id,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        // this.loader = true
        // this.loaderservice.showLoader = true
        // this._apiService.getEnrolledMembersListByType(this.selectedBusiness.hash_id,this.selectedValue,this.pageNo)
      }
    });
  }

  getInvoiceAccess(serviceType: any): boolean {
    if (this.selectedBusiness.is_owner) return true;
    else {
      const ssa = this.selectedBusiness.shop_invoice_access;
      const hsa = this.selectedBusiness.home_invoice_access;
      const vsa = this.selectedBusiness.virtual_invoice_access;

      const bsss = this.selectedBusiness.shop_service_status;
      const bhss = this.selectedBusiness.home_service_status;
      const bvss = this.selectedBusiness.virtual_service_status;

      if (
        (ssa == "1" && bsss != "2" && serviceType == "1") ||
        (hsa == "1" && bhss != "2" && serviceType == "0") ||
        (vsa == "1" && bvss != "2" && serviceType == "2")
      ) {
        return true;
      }
    }

    return false;
  }

  // NEW THINGS
  memberimg: any = {
    img: null,
    thumb: null,
  };
  public memberData: any = {
    price: 0,
    discount: 0,
    coupon_discount: 0,
    billing_period: 2,
    name: "",
    phone: "",
  };
  isPhoneDisabled: boolean = false;
  name: any;
  phone: any;
  countryList: {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
    preferred?: any;
  }[] = COUNTRY_CODES;

  selectedCountryCode: any = this.countryList.find(
    (country) => country.dial_code === "+91",
  );
  onCountrySelected(event: any): void {
    this.searchString.reset();
    this.countryList = COUNTRY_CODES;
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < COUNTRY_CODES.length; i++) {
      let option = COUNTRY_CODES[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }

  formChecker() {
    if (this.phone) {
      if (this.phone.length >= 3 && this.phone.length <= 17) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  searchForAccountByPhone() {
    if (this.phone && this.phone.length >= 3) {
      this.loaderservice.showLoader = true;
      this.resetPartial();
      this.apiservice.getAccountDataByPhoneNumber(
        this.selectedBusiness.hash_id,
        this.selectedCountryCode.dial_code,
        this.phone,
      );
    }
  }

  assetType: number = 0;
  public fileName: string = "";
  public assetList: any[] = [];
  onUploadImage(event: any) {
    this.assetType = 0;
    console.log(event);
    console.log(event.target);

    console.log(event.target.files);
    if (event.target.value === "") {
      // this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;

    if (this.fileName.includes(" ")) {
      this.fileName = this.fileName.replace(/\s+/g, "_");
    }
    let sizeinKb = +event.target.files[0].size / 1000;
    // if (sizeinKb > 1021) {
    //   this._snackBar.open('Image size should not exceed more then 1 mb', 'Ok');
    //   return;
    // }
    let extension = this.fileName.substring(this.fileName.lastIndexOf(".") + 1);
    const mimeType = event.target.files[0].type;
    console.log(extension);
    // this.assetList.push({
    //   assetName: this.fileName,
    // });
    // this.loader = true;
    let formData: FormData = new FormData();
    formData.append("recfile", event.target.files[0]);

    if (mimeType.startsWith("image/")) {
      console.log("image");
      if (sizeinKb > 5120) {
        // this.loader = false;
        this._snackBar.open(
          "Image size should not exceed more then 1 mb",
          "Ok",
        );
        return;
      }
      this.assetType = 1;
      this.loaderservice.showLoader = true;
      this.apiservice.uploadAssets(formData, 2);
      return;
    }
    if (mimeType.startsWith("video/")) {
      console.log("Video");
      if (sizeinKb > 15360) {
        // this.loader = false;
        this._snackBar.open(
          "Image size should not exceed more then 1 mb",
          "Ok",
        );
        return;
      }
      this.assetType = 2;
      this.loaderservice.showLoader = true;
      this.apiservice.uploadAssets(formData, 3);
      return;
    }
    // this.loader = false;
    this._snackBar.open("File format not supported", "Ok");
  }

  selectedDays: any = [];
  tConv24(time24: any) {
    let ts: any = time24;
    let H: any = +ts.substr(0, 2);
    let h: any = H % 12 || 12;
    h = h < 10 ? "0" + h : h; // leading 0 at the left for 1 digit hours
    var ampm = H < 12 ? " AM" : " PM";
    ts = h + ts.substr(2, 3) + ampm;
    return ts;
  }
  startTime: any = null;
  endTime: any = null;

  removeSelectedDay(index: any) {
    console.log(index);

    this.selectedDays.splice(index, 1);
  }

  getOneHourSlot(date: Date) {
    // Convert to local time string in 24-hour format
    const localTimeString = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    // Get hours and minutes
    let [hours, minutes] = localTimeString.split(":").map(Number);

    // Adjust hours based on minutes (round down to nearest hour)
    let startHour = hours;

    // Calculate next hour
    let endHour = (startHour + 1) % 24;

    // Format hours to always be 2 digits (e.g., 08:00, 23:00)
    const formatHour = (hour: any) => hour.toString().padStart(2, "0");

    // Return the 1-hour slot in 24-hour format
    return {
      start: `${formatHour(startHour)}:00`,
      end: `${formatHour(endHour)}:00`,
    };
  }
  getDayName(dayNumber: any) {
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    // Ensure the input is a valid day number (0-6)
    if (dayNumber >= 0 && dayNumber <= 6) {
      return daysOfWeek[dayNumber];
    } else {
      return "Invalid day number";
    }
  }
  isCurrentDateInRange(start_date: string, end_date: string): boolean {
    const currentDate = new Date();
    const startDate = new Date(start_date);
    const endDate = new Date(end_date);

    // Normalize the dates by setting the time to 00:00:00
    const normalizeDate = (date: Date): Date => {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };

    const normalizedCurrentDate = normalizeDate(currentDate);
    const normalizedStartDate = normalizeDate(startDate);
    const normalizedEndDate = normalizeDate(endDate);

    // Check if the current date is between start and end date (inclusive)
    return (
      normalizedCurrentDate >= normalizedStartDate &&
      normalizedCurrentDate <= normalizedEndDate
    );
  }

  openTimings() {
    // this.loader.showLoader = true
    let dialogref = this._modelRef.open(AddJoiningInterestTimingsComponent, {
      width: "450px",
      data: {
        title: "Select day and time",
        serviceType: this.selectedServiceType,
      },
    });

    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        console.log(res);
        res.forEach((element: any) => {
          this.selectedDays.push(element);
        });
      }
    });
  }

  changeServiceType(type: string) {
    this.selectedJobs = [];
    this.memberData.price = 0;
    this.selectedServiceType = type;
    this.loaderservice.showLoader = true;
    this.apiservice.getServicesTypesList(
      this.selectedBusiness.entity_public_hash_id,
      "0",
      "0",
    );
    this.apiservice.getEntityProductList(this.selectedBusiness.hash_id, "1");
  }

  selectedJobs: any = [];
  serviceList: any = [];

  selectServices(item: any) {
    console.log(item);

    const index = this.serviceList.findIndex(
      (x: any) => x.hash_id == item.hash_id,
    );
    this.serviceList[index].selectedCount = 1;

    this.serviceList[index].price =
      this.selectedServiceType == "0"
        ? item.discountStatus == 1
          ? item.homeDiscountedPrice
          : item.home_rate
        : this.selectedServiceType == "1"
          ? item.discountStatus == 1
            ? item.shopDiscountedPrice
            : item.shop_rate
          : item.discountStatus == 1
            ? item.virtual_discounted_amount
            : item.virtual_rate;

    this.selectedJobs.push(this.serviceList[index]);
    if (this.selectedServiceType == "0") {
      if (
        this.serviceList[index].discountStatus &&
        this.serviceList[index].discountStatus == 1
      ) {
        this.memberData.price += this.serviceList[index].homeDiscountedPrice;
      } else if (
        !this.serviceList[index].discountStatus ||
        this.serviceList[index].discountStatus == 0
      ) {
        this.memberData.price += this.serviceList[index].home_rate;
      }
    } else if (this.selectedServiceType == "1") {
      if (
        this.serviceList[index].discountStatus &&
        this.serviceList[index].discountStatus == 1
      ) {
        this.memberData.price += this.serviceList[index].shopDiscountedPrice;
      } else if (
        !this.serviceList[index].discountStatus ||
        this.serviceList[index].discountStatus == 0
      ) {
        this.memberData.price += this.serviceList[index].shop_rate;
      }
    } else if (this.selectedServiceType == "2") {
      if (
        this.serviceList[index].discountStatus &&
        this.serviceList[index].discountStatus == 1
      ) {
        this.memberData.price +=
          this.serviceList[index].virtual_discounted_amount;
      } else if (
        !this.serviceList[index].discountStatus ||
        this.serviceList[index].discountStatus == 0
      ) {
        this.memberData.price += this.serviceList[index].virtual_rate;
      }
    }
    this.serviceList[index].toShow = false;
    // this.calculateCouponDiscount();
  }

  productsList: any = [];
  selectedProducts: any = [];
  selectProducts(item: any) {
    if (item.entity_product_hash) {
      console.log(item);

      const index = this.productsList.findIndex(
        (x: any) => x.hash_id == item.entity_product_hash,
      );
      if (index != -1) {
        this.productsList[index].selectedCount = item.product_qty;
        item.selectedCount = item.product_qty;
        this.productsList[index].price = item.rate;
        this.selectedProducts.push(this.productsList[index]);
        if (this.selectedServiceType == "0") {
          if (
            this.productsList[index].discount_status &&
            this.productsList[index].discount_status == 1
          ) {
            this.memberData.price +=
              this.productsList[index].home_discounted_price;
          } else if (
            !this.productsList[index].discount_status ||
            this.productsList[index].discount_status == 0
          ) {
            this.memberData.price += this.productsList[index].home_price;
          }
        } else if (this.selectedServiceType == "1") {
          if (
            this.productsList[index].discount_status &&
            this.productsList[index].discount_status == 1
          ) {
            this.memberData.price +=
              this.productsList[index].shop_discounted_price;
          } else if (
            !this.productsList[index].discount_status ||
            this.productsList[index].discount_status == 0
          ) {
            this.memberData.price += this.productsList[index].shop_price;
          }
        } else if (this.selectedServiceType == "2") {
          if (
            this.productsList[index].discount_status &&
            this.productsList[index].discount_status == 1
          ) {
            this.memberData.price +=
              this.productsList[index].virtual_discounted_price;
          } else if (
            !this.productsList[index].discount_status ||
            this.productsList[index].discount_status == 0
          ) {
            this.memberData.price += this.productsList[index].virtual_price;
          }
        }
        this.productsList[index].toShow = false;
      }
    } else if (item.hash_id) {
      console.log(item);

      const index = this.productsList.findIndex(
        (x: any) => x.hash_id == item.hash_id,
      );
      this.productsList[index].selectedCount = 1;
      this.productsList[index].price =
        this.selectedServiceType == "0"
          ? item.discount_status == 1
            ? item.home_discounted_price
            : item.home_price
          : this.selectedServiceType == "1"
            ? item.discount_status == 1
              ? item.shop_discounted_price
              : item.shop_price
            : item.discount_status == 1
              ? item.virtual_discounted_price
              : item.virtual_price;
      this.selectedProducts.push(this.productsList[index]);
      if (this.selectedServiceType == "0") {
        if (
          this.productsList[index].discount_status &&
          this.productsList[index].discount_status == 1
        ) {
          this.memberData.price +=
            this.productsList[index].home_discounted_price;
        } else if (
          !this.productsList[index].discount_status ||
          this.productsList[index].discount_status == 0
        ) {
          this.memberData.price += this.productsList[index].home_price;
        }
      } else if (this.selectedServiceType == "1") {
        if (
          this.productsList[index].discount_status &&
          this.productsList[index].discount_status == 1
        ) {
          this.memberData.price +=
            this.productsList[index].shop_discounted_price;
        } else if (
          !this.productsList[index].discount_status ||
          this.productsList[index].discount_status == 0
        ) {
          this.memberData.price += this.productsList[index].shop_price;
        }
      } else if (this.selectedServiceType == "2") {
        if (
          this.productsList[index].discount_status &&
          this.productsList[index].discount_status == 1
        ) {
          this.memberData.price +=
            this.productsList[index].virtual_discounted_price;
        } else if (
          !this.productsList[index].discount_status ||
          this.productsList[index].discount_status == 0
        ) {
          this.memberData.price += this.productsList[index].virtual_price;
        }
      }
      this.productsList[index].toShow = false;
    }
    // this.calculateCouponDiscount();
  }

  decreaseServiceCount(item: any, index: any) {
    if (this.selectedJobs[index].selectedCount == 1) {
      const index1 = this.serviceList.findIndex(
        (x: any) => x.hash_id == item.hash_id,
      );
      // const index1 = this.selectedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);

      if (this.selectedServiceType == "0") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.memberData.price -= this.selectedJobs[index].homeDiscountedPrice;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.memberData.price -= this.selectedJobs[index].home_rate;
        }
      } else if (this.selectedServiceType == "1") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.memberData.price -= this.selectedJobs[index].shopDiscountedPrice;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.memberData.price -= this.selectedJobs[index].shop_rate;
        }
      } else if (this.selectedServiceType == "2") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.memberData.price -=
            this.selectedJobs[index].virtual_discounted_amount;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.memberData.price -= this.selectedJobs[index].virtual_rate;
        }
      }

      this.serviceList[index1].toShow = true;
      this.selectedJobs.splice(index, 1);
    } else {
      item.price -= item.price / item.selectedCount;
      this.selectedJobs[index].selectedCount--;

      if (this.selectedServiceType == "0") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.memberData.price -= this.selectedJobs[index].homeDiscountedPrice;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.memberData.price -= this.selectedJobs[index].home_rate;
        }
      } else if (this.selectedServiceType == "1") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.memberData.price -= this.selectedJobs[index].shopDiscountedPrice;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.memberData.price -= this.selectedJobs[index].shop_rate;
        }
      } else if (this.selectedServiceType == "2") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.memberData.price -=
            this.selectedJobs[index].virtual_discounted_amount;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.memberData.price -= this.selectedJobs[index].virtual_rate;
        }
      }
    }
    // this.calculateCouponDiscount();
  }
  increaseServiceCount(item: any, index: any) {
    item.price += item.price / item.selectedCount;
    this.selectedJobs[index].selectedCount++;

    // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    // const index1 = this.selectedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);

    if (this.selectedServiceType == "0") {
      if (this.selectedJobs[index].discountStatus == 1) {
        this.memberData.price += this.selectedJobs[index].homeDiscountedPrice;
      } else if (this.selectedJobs[index].discountStatus == 0) {
        this.memberData.price += this.selectedJobs[index].home_rate;
      }
    } else if (this.selectedServiceType == "1") {
      if (this.selectedJobs[index].discountStatus == 1) {
        this.memberData.price += this.selectedJobs[index].shopDiscountedPrice;
      } else if (this.selectedJobs[index].discountStatus == 0) {
        this.memberData.price += this.selectedJobs[index].shop_rate;
      }
    } else if (this.selectedServiceType == "2") {
      if (this.selectedJobs[index].discountStatus == 1) {
        this.memberData.price +=
          this.selectedJobs[index].virtual_discounted_amount;
      } else if (this.selectedJobs[index].discountStatus == 0) {
        this.memberData.price += this.selectedJobs[index].virtual_rate;
      }
    }
    // this.calculateCouponDiscount();
  }

  removeSelectedJobs(item: any) {
    console.log(item);

    const index = this.serviceList.findIndex(
      (x: any) => x.hash_id == item.hash_id,
    );
    const index1 = this.selectedJobs.findIndex(
      (x: any) => x.hash_id == item.hash_id,
    );
    this.memberData.price -= item.price;
    // if (this.selectedServiceType == "0") {
    //   if (this.selectedJobs[index1].discountStatus == 1) {
    //     this.memberData.price -=
    //       this.selectedJobs[index1].homeDiscountedPrice *
    //       this.selectedJobs[index1].selectedCount;
    //   } else if (this.selectedJobs[index1].discountStatus == 0) {
    //     this.memberData.price -=
    //       this.selectedJobs[index1].home_rate *
    //       this.selectedJobs[index1].selectedCount;
    //   }
    // } else if (this.selectedServiceType == "1") {
    //   if (this.selectedJobs[index1].discountStatus == 1) {
    //     this.memberData.price -=
    //       this.selectedJobs[index1].shopDiscountedPrice *
    //       this.selectedJobs[index1].selectedCount;
    //   } else if (this.selectedJobs[index1].discountStatus == 0) {
    //     this.memberData.price -=
    //       this.selectedJobs[index1].shop_rate *
    //       this.selectedJobs[index1].selectedCount;
    //   }
    // } else if (this.selectedServiceType == "2") {
    //   if (this.selectedJobs[index1].discountStatus == 1) {
    //     this.memberData.price -=
    //       this.selectedJobs[index1].virtual_discounted_amount *
    //       this.selectedJobs[index1].selectedCount;
    //   } else if (this.selectedJobs[index1].discountStatus == 0) {
    //     this.memberData.price -=
    //       this.selectedJobs[index1].virtual_rate *
    //       this.selectedJobs[index1].selectedCount;
    //   }
    // }

    this.serviceList[index].toShow = true;
    this.selectedJobs.splice(index1, 1);
    // this.calculateCouponDiscount();
  }
  changeServicePrice(item: any) {
    console.log(item.price);
    this.memberData.price = 0;
    this.selectedJobs.forEach((element: any) => {
      this.memberData.price += element.price;
    });
    this.selectedProducts.forEach((element: any) => {
      this.memberData.price += element.price;
    });
    this.form.get("items")!.value.forEach((element: any) => {
      this.memberData.price += +element.price;
    });

    this.checkIfEmpty();
    // this.calculateCouponDiscount();
    // this.calculateDiscount()
  }
  emptyCheck: boolean = false;
  checkIfEmpty() {
    this.selectedJobs.forEach((element: any) => {
      if (!element.price || element.price == "") {
        this.emptyCheck = true;
      } else {
        this.emptyCheck = false;
      }
    });
    console.log(this.emptyCheck);
  }

  decreaseProductCount(item: any, index: any) {
    if (this.selectedProducts[index].selectedCount == 1) {
      const index1 = this.productsList.findIndex(
        (x: any) => x.hash_id == item.hash_id,
      );
      // const index1 = this.selectedProducts.findIndex( (x:any)=>x.hash_id == item.hash_id);

      if (this.selectedServiceType == "0") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.memberData.price -=
            this.selectedProducts[index].home_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.memberData.price -= this.selectedProducts[index].home_price;
        }
      } else if (this.selectedServiceType == "1") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.memberData.price -=
            this.selectedProducts[index].shop_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.memberData.price -= this.selectedProducts[index].shop_price;
        }
      } else if (this.selectedServiceType == "2") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.memberData.price -=
            this.selectedProducts[index].virtual_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.memberData.price -= this.selectedProducts[index].virtual_price;
        }
      }

      this.productsList[index1].toShow = true;
      this.selectedProducts.splice(index, 1);
    } else {
      item.price -= item.price / item.selectedCount;
      this.selectedProducts[index].selectedCount--;

      if (this.selectedServiceType == "0") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.memberData.price -=
            this.selectedProducts[index].home_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.memberData.price -= this.selectedProducts[index].home_price;
        }
      } else if (this.selectedServiceType == "1") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.memberData.price -=
            this.selectedProducts[index].shop_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.memberData.price -= this.selectedProducts[index].shop_price;
        }
      } else if (this.selectedServiceType == "2") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.memberData.price -=
            this.selectedProducts[index].virtual_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.memberData.price -= this.selectedProducts[index].virtual_price;
        }
      }
    }
    // this.calculateCouponDiscount();
  }
  increaseProductCount(item: any, index: any) {
    item.price += item.price / item.selectedCount;
    this.selectedProducts[index].selectedCount++;

    // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    // const index1 = this.selectedProducts.findIndex( (x:any)=>x.hash_id == item.hash_id);

    if (this.selectedServiceType == "0") {
      if (this.selectedProducts[index].discount_status == 1) {
        this.memberData.price +=
          this.selectedProducts[index].home_discounted_price;
      } else if (this.selectedProducts[index].discount_status == 0) {
        this.memberData.price += this.selectedProducts[index].home_price;
      }
    } else if (this.selectedServiceType == "1") {
      if (this.selectedProducts[index].discount_status == 1) {
        this.memberData.price +=
          this.selectedProducts[index].shop_discounted_price;
      } else if (this.selectedProducts[index].discount_status == 0) {
        this.memberData.price += this.selectedProducts[index].shop_price;
      }
    } else if (this.selectedServiceType == "2") {
      if (this.selectedProducts[index].discount_status == 1) {
        this.memberData.price +=
          this.selectedProducts[index].virtual_discounted_price;
      } else if (this.selectedProducts[index].discount_status == 0) {
        this.memberData.price += this.selectedProducts[index].virtual_price;
      }
    }
    // this.calculateCouponDiscount();
  }

  removeSelectedProducts(item: any) {
    console.log(item);

    const index = this.productsList.findIndex(
      (x: any) => x.hash_id == item.hash_id,
    );
    const index1 = this.selectedProducts.findIndex(
      (x: any) => x.hash_id == item.hash_id,
    );
    this.memberData.price -= item.price;
    // if (this.selectedServiceType == "0") {
    //   if (this.selectedProducts[index1].discount_status == 1) {
    //     this.memberData.price -=
    //       this.selectedProducts[index1].home_discounted_price *
    //       this.selectedProducts[index1].selectedCount;
    //   } else if (this.selectedProducts[index1].discount_status == 0) {
    //     this.memberData.price -=
    //       this.selectedProducts[index1].home_price *
    //       this.selectedProducts[index1].selectedCount;
    //   }
    // } else if (this.selectedServiceType == "1") {
    //   if (this.selectedProducts[index1].discount_status == 1) {
    //     this.memberData.price -=
    //       this.selectedProducts[index1].shop_discounted_price *
    //       this.selectedProducts[index1].selectedCount;
    //   } else if (this.selectedProducts[index1].discount_status == 0) {
    //     this.memberData.price -=
    //       this.selectedProducts[index1].shop_price *
    //       this.selectedProducts[index1].selectedCount;
    //   }
    // } else if (this.selectedServiceType == "2") {
    //   if (this.selectedProducts[index1].discount_status == 1) {
    //     this.memberData.price -=
    //       this.selectedProducts[index1].virtual_discounted_price *
    //       this.selectedProducts[index1].selectedCount;
    //   } else if (this.selectedProducts[index1].discount_status == 0) {
    //     this.memberData.price -=
    //       this.selectedProducts[index1].virtual_price *
    //       this.selectedProducts[index1].selectedCount;
    //   }
    // }

    this.productsList[index].toShow = true;
    this.selectedProducts.splice(index1, 1);
    // this.calculateCouponDiscount();
  }

  changeProductPrice(item: any) {
    console.log(item.price);
    this.memberData.price = 0;
    this.selectedJobs.forEach((element: any) => {
      this.memberData.price += element.price;
    });
    this.selectedProducts.forEach((element: any) => {
      this.memberData.price += element.price;
    });
    this.form.get("items")!.value.forEach((element: any) => {
      this.memberData.price += +element.price;
    });

    this.checkIfEmptyForProduct();
    // this.calculateCouponDiscount();
    // this.calculateDiscount()
  }

  emptyCheckForProduct: boolean = false;
  checkIfEmptyForProduct() {
    this.selectedProducts.forEach((element: any) => {
      if (!element.price || element.price == "") {
        this.emptyCheckForProduct = true;
      } else {
        this.emptyCheckForProduct = false;
      }
    });
  }

  // Create a new form group for each item
  itemOptions: string[] = ["Item1", "Item2", "Item3", "Item4"]; // List of options
  filteredOptions: Observable<any[]>[] = [];
  createItem(): FormGroup {
    const itemGroup = this.fb.group({
      name: ["", Validators.required],
      price: ["", Validators.required],
      count: [1, Validators.required],
      tax_slab: ["default"],
    });

    const filterControl = itemGroup.get("name") as FormControl;

    // // Listen for changes, trigger API call if length > 3
    // const filteredOption = filterControl.valueChanges.pipe(
    //   debounceTime(300), // Add debounce to reduce API calls
    //   filter((value) => value.length > 2), // Only call API if input length > 3
    //   switchMap((value) => this.fetchOptions(value)) // Fetch options from API
    // );

    const priceControl = itemGroup.get("price") as FormControl;

    // Store the previous value to subtract when the value changes
    let previousPrice = 0;

    priceControl.valueChanges.subscribe((value) => {
      // Convert the input value to a number
      const parsedValue = +value;
      if (!isNaN(parsedValue) && value !== "" && value !== undefined) {
        // Subtract the previous price before adding the new one
        this.memberData.price = this.memberData.price - previousPrice + +value;

        // Update the previous price to the new value for future changes
        previousPrice = +value;
      } else {
      }
      // this.calculateCouponDiscount();
    });

    // this.filteredOptions.push(filteredOption);
    // console.log(this.filteredOptions);

    return itemGroup;
  }

  createFieldWithItem(item: any): FormGroup {
    const itemGroup = this.fb.group({
      name: [
        {
          item_name: item.item_name,
          item_desc: item.item_description,
          hash_id: item.inventory_item_hash,
          image_thumb_url: null,
        },
        Validators.required,
      ],
      price: [item.item_price, Validators.required],
      count: [item.item_qty, Validators.required],
      tax_slab: [item.tax_slab_hash ? item.tax_slab_hash : "default"],
    });

    const filterControl = itemGroup.get("name") as FormControl;

    const filteredOption = filterControl.valueChanges.pipe(
      debounceTime(300),
      filter((value) => typeof value === "string" && value.length > 2),
      switchMap((value) => this.fetchOptions(value)),
    );
    this.filteredOptions.push(filteredOption);

    const priceControl = itemGroup.get("price") as FormControl;
    let previousPrice = item.item_price; // ✅ Fix: initialize correctly

    // ✅ Add initial item price once
    this.memberData.price += item.item_price;

    // ✅ Skip first emission to prevent double count
    priceControl.valueChanges.subscribe((value) => {
      const parsedValue = +value;
      if (!isNaN(parsedValue) && value !== "" && value !== undefined) {
        this.memberData.price =
          this.memberData.price - previousPrice + parsedValue;
        previousPrice = parsedValue;
      }
      // this.calculateCouponDiscount();
    });

    return itemGroup;
  }

  displayItemName(item: any): string {
    return item ? item.item_name : ""; // Return only the item_name for display
  }

  // Call the API to fetch options based on the user's input
  fetchOptions(value: string): Observable<string[]> {
    // Example API call: Replace with your actual API endpoint
    return this.http.get<string[]>(
      `https://user-services.lookzup.com/dev/getInventoryDataByKeyword?entityHashId=${this.selectedBusiness.hash_id}&searchKey=${value}&pageNo=1&count=25`,
    );
  }

  // Filter the autocomplete options based on the user's input
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.itemOptions.filter((option) =>
      option.toLowerCase().includes(filterValue),
    );
  }

  // Get the form array of items
  get items(): FormArray {
    return this.form.get("items") as FormArray;
  }

  // Add new form field
  addFormField(): void {
    this.items.push(this.createItem());
  }

  // Remove a form field by index
  removeFormField(index: number): void {
    this.memberData.price -= +this.items.at(index).value.price;

    this.items.removeAt(index);
    // this.calculateCouponDiscount();
  }

  // Decrease the count and remove the form if count becomes 0
  decreaseCount(index: number): void {
    const currentItem = this.items.at(index);
    const currentCount = currentItem.get("count")!.value;

    if (currentCount > 1) {
      currentItem.get("count")!.setValue(currentCount - 1);
    } else {
      // this.memberData.price -= +currentItem.get('price')!.value
      this.removeFormField(index); // Remove the form when count is 0
    }
  }

  // Increase the count
  increaseCount(index: number): void {
    const currentItem = this.items.at(index);
    currentItem.get("count")!.setValue(currentItem.get("count")!.value + 1);
  }

  taxSlabData: any = [];
  isEntityForeign: any = "0";
  pay_in_advance: any = 0;
  employeeList: any = [];
  selectedEmployee: any;
  goback() {
    //  this.scrollToTop()

    this.step -= 1;
  }
  gonext() {
    // this.scrollToTop()
    this.step += 1;
    if (this.selectedServiceType == "0") {
      this.toShowMap = true;
      this.toShowSessionInfo = false;
      if (this.step == 5) {
        this.contactPhone = this.memberData.phone;
        this.contactselectedCountryCode = this.countryList.find(
          (country) => country.dial_code === this.selectedCountryCode.dial_code,
        );

        if (!this.formattedAddress) {
          setTimeout(() => {
            this.initializeMap(
              {
                latitude: "28.6139298",
                longitude: "77.2088282",
              },
              "New Delhi, Delhi, India",
            );
          }, 1);
        } else {
          setTimeout(() => {
            this.initializeMap(
              {
                latitude: this.lat,
                longitude: this.lng,
              },
              this.formattedAddress,
            );
          }, 1);
        }
      }
    } else if (this.selectedServiceType == "2") {
      this.toShowSessionInfo = true;
      this.toShowMap = false;
      if (this.step == 5) {
        if (this.membershipSettings?.default_online_session_link_status == 1) {
          this.online_session_link =
            this.membershipSettings?.default_online_session_link;
          this.online_session_app =
            this.membershipSettings?.default_online_session_app;
        }
      }
    } else {
      this.toShowMap = this.toShowSessionInfo = false;
    }
  }

  getDisabledStatus(): boolean {
    if (this.step === 2) {
      return (
        this.formChecker() || this.namechecker() || !this.memberData.start_date
      );
    } else if (this.step === 3) {
      return (
        this.selectedJobs.length == 0 ||
        this.selectedDaysChecker() ||
        this.form.invalid ||
        this.checkIfEmpty2() ||
        this.checkIfEmptyForProduct2()
      );
    } else if (this.step === 4) {
      return false;
    }

    return false;
  }

  namechecker() {
    if (this.memberData.name && this.memberData.name.trim() !== "") {
      return false; // valid
    } else {
      return true; // invalid
    }
  }

  selectedDaysChecker() {
    if (this.isEntityIndividual == "1") {
      if (this.selectedDays.length == 0) {
        return true;
      } else {
        return false;
      }
    } else if (this.isEntityIndividual == "0") {
      return false;
    } else {
      return false;
    }
  }
  checkIfEmpty2() {
    return this.selectedJobs.some(
      (element: any) => element.price === "" || element.price == null,
    );
  }

  checkIfEmptyForProduct2() {
    return this.selectedProducts.some(
      (element: any) => element.price === "" || element.price == null,
    );
  }

  serviceInfo: any = [];
  productInfo: any = [];
  onPost() {
    this.serviceInfo = [];

    this.selectedJobs.forEach((element: any) => {
      this.serviceInfo.push({
        service_type_hash: element.hash_id,
        service_name: element.serviceName,
        service_qty: element.selectedCount,
        service_description: element.description,
        service_img_url: element.imgUrl,
        service_rate: element.price,
        service_time: element.approxTime,
        service_sac_code: element.service_sac_code,
        tax_slab_hash: element.tax_slab_hash,
      });
    });

    this.productInfo = this.selectedProducts.map((item: any) => {
      return {
        product_name: item.product_name,
        product_desc: item.product_desc,
        entity_product_hash: item.hash_id,
        product_img_url: item.thumb_image_url,
        product_price: item.price,
        product_qty: item.selectedCount,
        tax_slab_hash: item.tax_slab_hash,
        hsn_code: item.product_hsn_code,
      };
    });

    // --------------- new data formation --------------------

    let obj = {
      // "hash_id": "21b296bb295a9c1800c8aa373bb6a6601acf5950",
      entity_hash: this.selectedBusiness.hash_id,
      name: this.memberData.name ? this.memberData.name : "New Customer",
      country_code: this.selectedCountryCode.dial_code,
      phone: this.memberData.phone ? this.memberData.phone : "0000000000",
      gender: this.memberData.gender ? this.memberData.gender : null,
      billing_period: this.memberData.billing_period
        ? this.memberData.billing_period
        : null,
      service_mode: this.selectedServiceType,
      dob: this.memberData.dob ? this.formatDate1(this.memberData.dob) : null,
      start_date: this.memberData.start_date
        ? this.formatDate1(this.memberData.start_date)
        : null,
      image_url: this.memberimg.img ?? null,
      image_thumb_url: this.memberimg.thumb ?? null,
      email: this.memberData.email,
      services: this.serviceInfo,
      products: this.productInfo,
      address: this.memberData.address ?? null,
      timings: this.selectedDays.map((item: any) => {
        return {
          weekday: item.day.day,
          start_time: item.startTime,
          end_time: item.endTime,
        };
      }),
      custom_items: this.form.get("items")!.value.map((item: any) => {
        return {
          item_name: item.name.item_name ? item.name.item_name : item.name,
          item_desc: item.name.item_desc ?? "",
          item_inventory_hash: item.name.hash_id ?? "",
          item_img_url: item.name.image_thumb_url ?? "",
          item_qty: item.count,
          item_price: +item.price,
          tax_slab_hash: item.tax_slab == "default" ? null : item.tax_slab,
        };
      }),
      note: this.memberData.note,
      default_assign_to_hash: this.selectedEmployee?.employeeHashId ?? null,
      subscription_fee: this.memberData.price,
      discount: this.memberData.discount,
      net_payable: this.memberData.price - this.memberData.discount,
      pay_in_advance: this.pay_in_advance,
      creation_date: this.formatDateString(new Date()),
      created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
     online_session_link: undefined as any,
      online_session_notes: undefined as any,
      online_session_app: undefined as any,
      member_address: undefined as any,
    };

    if (this.selectedServiceType == "0") {
      // INSERT ADDRESS OBJ
      obj.member_address = {
          landmark: this.landmark,
          street_name: this.streetName,
          house_no: this.houseNumber,
          city: this.selectedLocation.city,
          state: this.selectedLocation.state,
          country: this.selectedLocation.country,
          zip: this.selectedLocation.zip,
          lat: this.lat,
          lng: this.lng,
          address_line: this.formattedAddress,
          service_mode: this.selectedServiceType,
          status: 1,
          created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          country_code: this.contactselectedCountryCode.dial_code,
          phone: this.phone,
        };

        Object.keys(obj.member_address).forEach((key) => {
          if (
            (obj.member_address as any)[key] === null ||
            (obj.member_address as any)[key] ===
              undefined ||
            (obj.member_address as any)[key] === "" ||
            (obj.member_address as any)[key] === "null"
          ) {
            delete (obj.member_address as any)[key];
          }
        });
    }
    if (this.selectedServiceType == "2") {
      // INSERT ONLINE SESSION INFO OBJ
      obj.online_session_link = this.online_session_link;
      obj.online_session_notes =
        this.online_session_notes;
      obj.online_session_app = this.online_session_app;
    }

    Object.keys(obj).forEach((key) => {
      if ((obj as any)[key] === null || (obj as any)[key] === undefined) {
        delete (obj as any)[key];
      }
    });

    obj.services.forEach((element: any) => {
      Object.keys(element).forEach((key) => {
        if ((element as any)[key] === null) {
          delete (element as any)[key];
        }
      });
    });
    obj.products.forEach((element: any) => {
      Object.keys(element).forEach((key) => {
        if ((element as any)[key] === null) {
          delete (element as any)[key];
        }
      });
    });
    obj.custom_items.forEach((element: any) => {
      Object.keys(element).forEach((key) => {
        if ((element as any)[key] === null) {
          delete (element as any)[key];
        }
      });
    });
    console.log(obj);

    this.loaderservice.showLoader = true;
    this.apiservice.addEdiEnrolledMember(obj);
  }

  formatDate1(dateStr: Date) {
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);

    return curdate;
  }

  formatDateString(inputDateString: Date): string {
    const inputDate = new Date(inputDateString);
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-indexed
    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = inputDate.getHours().toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const seconds = inputDate.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  resetEverything() {
    this.toShowMap = this.toShowSessionInfo = false;
    this.online_session_app =
      this.online_session_link =
      this.online_session_notes =
        null;
    this.googleAutoCompleteItems = [];
    this.selectedLocation = {};
    this.houseNumber = this.streetName = this.landmark = null;
    this.contactPhone = null;
    this.formattedAddress = null;
    this.step = 1;
    this.phone = null;
    // this.selectedServiceType = "1";
    this.memberimg = {
      img: null,
      thumb: null,
    };
    this.memberData = {
      price: 0,
      discount: 0,
      coupon_discount: 0,
      billing_period: 2,
      name: null,
      phone: null,
      address: null,
      dob: null,
      gender: null,
      email: null,
      start_date: null,
      note: null,
    };
    this.pay_in_advance = 0;
    this.selectedEmployee = null;
    this.selectedJobs = [];
    this.selectedProducts = [];
    this.items.clear();
    this.serviceList.forEach((element: any) => {
      element.toShow = true;
    });
    this.productsList.forEach((element: any) => {
      element.toShow = true;
    });
  }
  resetPartial() {
    this.toShowMap = this.toShowSessionInfo = false;
    this.online_session_app =
      this.online_session_link =
      this.online_session_notes =
        null;
    this.googleAutoCompleteItems = [];
    this.selectedLocation = {};
    this.houseNumber = this.streetName = this.landmark = null;
    this.contactPhone = null;
    this.formattedAddress = null;
    this.step = 1;
    // this.phone = null;
    // this.selectedServiceType = "1";
    this.memberimg = {
      img: null,
      thumb: null,
    };
    this.memberData = {
      price: 0,
      discount: 0,
      coupon_discount: 0,
      billing_period: 2,
      name: null,
      phone: null,
      address: null,
      dob: null,
      gender: null,
      email: null,
      start_date: null,
      note: null,
    };
    this.pay_in_advance = 0;
    this.selectedEmployee = null;
    this.selectedJobs = [];
    this.selectedProducts = [];
    this.items.clear();
    this.serviceList.forEach((element: any) => {
      element.toShow = true;
    });
    this.productsList.forEach((element: any) => {
      element.toShow = true;
    });
  }

  // -------------------- MAP THINGS ---------------------------
  @ViewChild("mapContainer", { static: false }) mapContainer!: ElementRef;
  contactselectedCountryCode: any = this.countryList.find(
    (country) => country.dial_code === "+91",
  );
  houseNumber: any;
  streetName: any;
  landmark: any;
  contactPhone: any;
  map!: google.maps.Map;
  marker!: google.maps.Marker;
  geocoder!: google.maps.Geocoder;
  lat: any;
  lng: any;
  initializeMap(address?: any, description?: any) {
    let mapOptions: google.maps.MapOptions;

    if (address && address.latitude && address.longitude) {
      this.lat = address.latitude;
      this.lng = address.longitude;
      mapOptions = {
        center: new google.maps.LatLng(address.latitude, address.longitude),
        zoom: 12,
      };
    } else {
      mapOptions = {
        center: new google.maps.LatLng(28.6139298, 77.2088282), // fallback (Delhi for example)
        zoom: 5,
      };
    }

    this.map = new google.maps.Map(this.mapContainer.nativeElement, mapOptions);

    // Create marker only if coordinates exist
    if (address && address.latitude && address.longitude) {
      this.marker = new google.maps.Marker({
        map: this.map,
        draggable: true,
        position: mapOptions.center,
      });

      this.geocoder = new google.maps.Geocoder();
      const latLng = new google.maps.LatLng(
        address.latitude,
        address.longitude,
      );
      this.geocodePosition(latLng, description);

      google.maps.event.addListener(this.marker, "dragend", (event: any) => {
        this.geocodePositionOverwrite(event.latLng);
      });
    }
  }

  // this.storeLocation( results[ 0 ].address_components, results[ 0 ].formatted_address );
  geocodePosition(latLng: google.maps.LatLng, description?: any) {
    console.log(latLng);
    console.log(description);

    this.geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          console.log(results[0]);
          // this.autocomplete.nativeElement.value = results[0].formatted_address;
          console.log("Address:", results[0].formatted_address);
          this.storeLocation(
            results[0].address_components,
            results[0].formatted_address,
            description ? description : results[0].formatted_address,
          );
          const location = results[0].geometry.location;
          this.lat = location.lat().toFixed(6);
          this.lng = location.lng().toFixed(6);
          console.log(this.lat, this.lng);
        } else {
          console.log("No results found");
        }
      } else {
        console.log("Geocoder failed due to:", status);
      }
    });
  }
  geocodePositionOverwrite(latLng: google.maps.LatLng) {
    console.log(latLng);

    this.geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          console.log(results[0]);
          // this.autocomplete.nativeElement.value = results[0].formatted_address;
          console.log("Address:", results[0].formatted_address);
          this.storeLocation(
            results[0].address_components,
            results[0].formatted_address,
            results[0].formatted_address,
          );
          const location = results[0].geometry.location;
          this.lat = location.lat().toFixed(6);
          this.lng = location.lng().toFixed(6);
        } else {
          console.log("No results found");
        }
      } else {
        console.log("Geocoder failed due to:", status);
      }
    });
  }

  // async getCurrentLocation(): Promise<any> {
  //   return new Promise(async (resolve, reject) => {
  //     if ('geolocation' in navigator) {
  //       navigator.geolocation.getCurrentPosition(
  //         async position => {
  //           const { latitude, longitude } = position.coords;
  //           try {
  //             resolve({ latitude, longitude});
  //           } catch (error) {
  //             reject('Error getting location info');
  //           }
  //         },
  //         error => reject(error)
  //       );
  //     } else {
  //       reject('Geolocation is not supported by your browser.');
  //     }
  //   });
  // }

  // async getCurrentLocation(): Promise<any> {
  //   try {
  //     const position = await Geolocation.getCurrentPosition();
  //     const coords = position.coords;
  //     console.log(JSON.stringify(position));

  //     return {
  //       latitude: coords.latitude.toString(),
  //       longitude: coords.longitude.toString(),
  //     };
  //   } catch (err) {
  //     console.error("Error fetching location", err);
  //     throw err;
  //   }
  // }
  location: any = "";
  targetaddress: any = "";
  selectedLocation: any = {};
  formattedAddress: any;
  storeLocation(location: any, formatted_address: any, description: any) {
    console.log(location);
    let address: any = {
      latitude: "",
      longitude: "",
      city: "",
      state: "",
      country: "",
      sublocality_level_1: "",
      zip: "",
    };

    location?.forEach((data: any) => {
      let type = data.types[0];
      console.log(type);
      if (type === "postal_code") {
        address.zip = data.long_name;
      } else if (type === "locality") {
        address.city = data.long_name;
      } else if (type === "administrative_area_level_1") {
        address.state = data.long_name;
      } else if (type === "country") {
        address.country = data.long_name;
      } else if (data.types.includes("sublocality_level_1")) {
        address.sublocality_level_1 = data.long_name;
      }
    });

    console.log(address);

    // ---------- ASSIGN TO KEYWORD ---------------

    const addressComponents = location || [];
    const priorityMap: any = {
      locality: null,
      administrative_area_level_1: null,
      country: null,
    };

    // Extract values based on priority
    addressComponents.forEach((data: any) => {
      const type = data.types[0];
      if (type in priorityMap && !priorityMap[type]) {
        priorityMap[type] = data.long_name;
      }
    });

    // Assign location based on priority
    this.location =
      priorityMap.locality ||
      priorityMap.administrative_area_level_1 ||
      priorityMap.country;

    address.latitude = this.lat ?? "";
    address.longitude = this.lng ?? "";
    address.formatted_address = description ?? "";

    this.selectedLocation = address;
    console.log(this.selectedLocation);

    this.formattedAddress = description;
    console.log(this.formattedAddress);
  }

  locationInput: string = "";
  googleAutoCompleteItems: any[] = [];
  GoogleAutocomplete: any;

  onInputChange() {
    this.locationSelected = false;
    if (!this.formattedAddress.trim()) {
      this.googleAutoCompleteItems = [];
      return;
    }

    this.GoogleAutocomplete.getPlacePredictions(
      { input: this.formattedAddress },
      (predictions: any, status: any) => {
        if (
          status === google.maps.places.PlacesServiceStatus.OK &&
          predictions
        ) {
          this.googleAutoCompleteItems = predictions;
        }
      },
    );

    console.log(this.googleAutoCompleteItems);
  }

  locationSelected = false;
  selectItem(item: any) {
    this.locationSelected = true; // ✅ user picked from list
    console.log(item);
    this.googleAutoCompleteItems = [];
    this.geocoder.geocode(
      {
        placeId: item.place_id,
      },
      (results: any, status: any) => {
        if (status === "OK" && results[0]) {
          this._ngZone.run(() => {
            // this.profileData.address_line = results[0].formatted_address;

            // this.locationSelected = true;
            let location_set: any = JSON.stringify(results[0].geometry);
            location_set = JSON.parse(location_set);
            let position = {
              lat: results[0].geometry.location.lat,
              lng: results[0].geometry.location.lng,
            };
            this.lat = location_set.location.lat;
            this.lng = location_set.location.lng;
            console.log(this.lat, this.lng);
            console.log("Latitude & Langitude", position);
            this.updateMapCoordinates(this.lat, this.lng, item.description);
            this.storeLocation(
              results[0].address_components,
              results[0].formatted_address,
              item.description,
            );
          });
        }
      },
    );
  }

  /**
   * Update map center and marker without recreating the google map instance.
   * lat/lng can be numbers or numeric strings.
   * opts: { zoom?: number, animate?: boolean } - animate isn't used (Google Maps JS has no built-in smooth pan),
   * but we keep opts for future extension.
   */
  updateMapCoordinates(
    lat: number | string,
    lng: number | string,
    description?: any,
  ) {
    const latNum = Number(lat);
    const lngNum = Number(lng);
    if (isNaN(latNum) || isNaN(lngNum)) {
      console.warn("updateMapCoordinates: invalid lat/lng", lat, lng);
      return;
    }

    // ensure map exists
    if (!this.map) {
      // If map hasn't been created yet, call initializeMap with these coords
      this.initializeMap({ latitude: latNum, longitude: lngNum }, description);
      return;
    }

    const latLng = new google.maps.LatLng(latNum, lngNum);
    this.map.setZoom(12);

    // center map
    this.map.setCenter(latLng);

    // create marker if missing
    if (!this.marker) {
      this.marker = new google.maps.Marker({
        map: this.map,
        draggable: true,
        position: latLng,
      });

      // add dragend listener once when marker created
      google.maps.event.addListener(this.marker, "dragend", (event: any) => {
        this.geocodePositionOverwrite(event.latLng);
      });
    } else {
      // move existing marker
      this.marker.setPosition(latLng);
    }

    // update geocoder results & component state
    if (!this.geocoder) this.geocoder = new google.maps.Geocoder();
    this.geocodePosition(latLng, description);

    // keep internal lat/lng in sync (string with fixed decimals if you prefer)
    this.lat = latNum.toFixed ? latNum.toFixed(6) : latNum;
    this.lng = lngNum.toFixed ? lngNum.toFixed(6) : lngNum;
  }
}
